import { HOTELS, NIGHT_OFFS, DAY_MULT } from './data.js';

const FAVS_KEY = 'houruse:favs:v1';
const SETTINGS_KEY = 'houruse:settings:v1';

const SUPPORTED_LANGS = new Set(['en', 'uz', 'ru', 'kz', 'kg', 'tj', 'tm']);
const SUPPORTED_CURRENCIES = new Set(['UZS', 'USD', 'EUR', 'RUB']);

export const state = {
  mode: 'day', // 'day' | 'night'
  city: 'Tashkent',
  hours: 3, // 3 | 6 | 9
  sel: null, // selected hotel index or null
  filtered: [], // indices of hotels in current view
  favs: new Set(), // favorited hotel indices
  showFavs: false, // when true, filter cards/markers to favorites
  lang: 'en', // 'en' | 'uz' | 'ru'
  currency: 'UZS', // 'UZS' | 'USD' | 'EUR' | 'RUB'
};

export const som = (n) => n.toLocaleString('en-US').replace(/,/g, '.');
export const shortP = (n) => Math.round(n / 1000) + 'k';

export function priceFor(h) {
  if (state.mode === 'night') {
    const off = NIGHT_OFFS[HOTELS.indexOf(h)];
    return {
      now: Math.round((h.rack * (100 - off)) / 1000) * 1000,
      was: h.rack,
      off,
    };
  }
  const m = DAY_MULT[state.hours] ?? 1;
  return {
    now: Math.round((h.dayBase * m) / 1000) * 1000,
    was: null,
    off: null,
  };
}

export function slots(h) {
  const start = parseInt(h.win.split('–')[0], 10);
  const out = [];
  for (let t = start; t <= start + 8 && t <= 21; t += 2) {
    out.push((t < 10 ? '0' : '') + t + ':00');
  }
  return out.slice(0, 5);
}

// ---------- favorites ----------

export function loadFavs() {
  try {
    const raw = localStorage.getItem(FAVS_KEY);
    if (raw) {
      const arr = JSON.parse(raw);
      if (Array.isArray(arr)) state.favs = new Set(arr.filter((n) => typeof n === 'number'));
    }
  } catch {
    /* ignore */
  }
}

function saveFavs() {
  try {
    localStorage.setItem(FAVS_KEY, JSON.stringify([...state.favs]));
  } catch {
    /* ignore */
  }
}

export function toggleFav(i) {
  if (state.favs.has(i)) state.favs.delete(i);
  else state.favs.add(i);
  saveFavs();
  return state.favs.has(i);
}

export function isFav(i) {
  return state.favs.has(i);
}

// ---------- supply stats ----------

export function totalRoomsLive() {
  return HOTELS.reduce((acc, h) => acc + h.left, 0);
}

export function roomsInCity(city) {
  return HOTELS.filter((h) => h.city === city).reduce((acc, h) => acc + h.left, 0);
}

// ---------- settings (lang + currency) ----------

export function loadSettings() {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (!raw) return;
    const s = JSON.parse(raw);
    if (s && typeof s === 'object') {
      if (SUPPORTED_LANGS.has(s.lang)) state.lang = s.lang;
      if (SUPPORTED_CURRENCIES.has(s.currency)) state.currency = s.currency;
    }
  } catch {
    /* ignore */
  }
}

function saveSettings() {
  try {
    localStorage.setItem(
      SETTINGS_KEY,
      JSON.stringify({ lang: state.lang, currency: state.currency }),
    );
  } catch {
    /* ignore */
  }
}

export function setLang(lang) {
  if (!SUPPORTED_LANGS.has(lang) || state.lang === lang) return false;
  state.lang = lang;
  saveSettings();
  return true;
}

export function setCurrency(cur) {
  if (!SUPPORTED_CURRENCIES.has(cur) || state.currency === cur) return false;
  state.currency = cur;
  saveSettings();
  return true;
}
